import Notification from './Notification';

export default function Notifications({ notifications = [] }) {
  return (
    <div>
      {notifications.map((item, index) => (
        <Notification key={index} item={item} />
      ))}
    </div>
  );
}
